import React from 'react';

import './PrivacyPolicy.css';
const PrivacyPolicy = () => {
    return (


        <div className="privacyPolicyWrapper">
         <div style={{ fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", padding: '1em' }}>
            <h2>Privacy Policy</h2>
            <p>
                Crispy Fries built the Drag Racing Lights app as a commercial application. This Service is provided by Crispy Fries
                and is intended for use as is.  This Privacy Policy explains how personal information is collected, used, and disclosed for users who choose to use this Service.  By using the Service, you agree to the collection and use of information in accordance with this policy. The
                personal information collected is used solely for providing and improving the Service. Your information will not
                be used or shared with anyone except as described in this Privacy Policy. The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible through the Drag Racing Lights app, unless otherwise defined here.
            </p>
            <p>
               
            </p>
            <p>
               
            </p>
            <p>
                
            </p>

            <p><strong>Information Collection and Use</strong></p>
            <p>
                To enhance your experience while using our Service, we may request certain personally identifiable information. Any information requested will remain on your device and is not collected or stored by us directly.
            </p>
            <p>The app may use third-party services that collect information to identify you.</p>

            <div>
                <p>Links to the privacy policies of third-party service providers used by the app:</p>
                <ul>
                    <li>
                        <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">
                            Google Play Services
                        </a>
                    </li>
                </ul>
            </div>

            <p><strong>Log Data</strong></p>
            <p>
                Please note that in the event of an error within the app, we may collect certain data and information (through third-party products) on your device, referred to as Log Data. This Log Data may include details such as your
                device’s Internet Protocol (IP) address, device name, operating system version, app configuration while using the Service, the time and date of usage, and other related statistics.
            </p>

            <p><strong>Cookies</strong></p>
            <p>
                Cookies are small data files commonly used as anonymous unique identifiers. These are sent to your browser
                from the websites you visit and are stored in your device’s internal memory.
            </p>
            <p>
                This Service does not use cookies directly. However, the app may incorporate third-party code and libraries that
                use cookies to collect information and enhance their services. You have the option to accept or refuse these cookies and to be notified when a cookie is being sent to your device. Please note that if you choose to refuse cookies, certain features of the Service may not function properly.
            </p>

            <p><strong>Service Providers</strong></p>
            <p>We may engage third-party companies and individuals for the following purposes:</p>
            <ul>
                <li>To facilitate and operate our Service</li>
                <li>To provide the Service on our behalf</li>
                <li>To perform Service-related tasks or</li>
                <li>To assist in analyzing how our Service is used.</li>
            </ul>
            <p>
                These third parties may have access to your personal information solely for the purpose of performing assigned tasks on our behalf. However, they are contractually obligated not to disclose or use the information for any
                other purpose.
            </p>

            <p><strong>Security</strong></p>
            <p>
                We value your trust in providing your personal information and strive to use commercially reasonable measures to protect it. However, please be aware that no method of transmission over the internet or electronic storageis completely secure and reliable, and we cannot guarantee absolute security.
            </p>

            <p><strong>Links to Other Sites</strong></p>
            <p>
                This Service may contain links to third-party websites. If you click on a third-party link, you will be redirected to that site. Please note that these external sites are not operated by us. We strongly encourage you to review the Privacy Policy of any third-party websites you visit. We have no control over and assume no responsibility for
                the content, privacy policies, or practices of any third-party sites or services.
            </p>

            <p><strong>Children’s Privacy</strong></p>
            <p>
                This Service is not intended for individuals under the age of 13. We do not knowingly collect personally
                identifiable information from children under 13 years of age. If we become aware that a child under 13 has
                provided personal information, we will promptly delete such information from our servers. If you are a parent
                or guardian and believe that your child has provided us with personal information, please contact us so that we can take appropriate action.
            </p>

            <p><strong>Changes to This Privacy Policy</strong></p>
            <p>
                We may update our Privacy Policy from time to time. Therefore, you are advised to review this page periodically for any changes. Any updates will be posted on this page and will become effective immediately upon posting.
            </p>

            <p><strong>Contact Us</strong></p>
            <p>
                If you have any questions or suggestions regarding this Privacy Policy, please feel free to contact us.
            </p>

            <p>
                This privacy policy page was created at{' '}
                <a href="https://privacypolicytemplate.net" target="_blank" rel="noopener noreferrer">
                    privacypolicytemplate.net
                </a>{' '}
                and modified/generated by{' '}
                <a
                    href="https://app-privacy-policy-generator.firebaseapp.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    App Privacy Policy Generator
                </a>
            </p>
        </div>

        </div>

       
    );
};

export default PrivacyPolicy;